
export const GEOFENCE_MANAGEMENT_LIST = 'GEOFENCE_MANAGEMENT_LIST';
export const GEOFENCE_MANAGEMENT_LIST_SUCCESS = 'GEOFENCE_MANAGEMENT_LIST_SUCCESS';
export const GEOFENCE_MANAGEMENT_LIST_ERROR = 'GEOFENCE_MANAGEMENT_LIST_ERROR';

export const DELETE_GEOFENCE_MANAGEMENT_SUCCESS = 'DELETE_GEOFENCE_MANAGEMENT_SUCCESS';
export const DELETE_GEOFENCE_MANAGEMENT_ERROR = 'DELETE_GEOFENCE_MANAGEMENT_ERROR';

export const GEOFENCE_MANAGEMENT_DETAILS = 'GEOFENCE_MANAGEMENT_DETAILS';
export const GEOFENCE_MANAGEMENT_DETAILS_SUCCESS = 'GEOFENCE_MANAGEMENT_DETAILS_SUCCESS';
export const GEOFENCE_MANAGEMENT_DETAILS_ERROR = 'GEOFENCE_MANAGEMENT_DETAILS_ERROR';

export const ADD_GEOFENCE_MANAGEMENT_DETAILS = 'ADD_GEOFENCE_MANAGEMENT_DETAILS';
export const ADD_GEOFENCE_MANAGEMENT_DETAILS_SUCCESS = 'ADD_GEOFENCE_MANAGEMENT_DETAILS_SUCCESS';
export const ADD_GEOFENCE_MANAGEMENT_DETAILS_ERROR = 'ADD_GEOFENCE_MANAGEMENT_DETAILS_ERROR';

export const UPDATE_GEOFENCE_MANAGEMENT = 'UPDATE_GEOFENCE_MANAGEMENT';
export const UPDATE_GEOFENCE_MANAGEMENT_SUCCESS = 'UPDATE_GEOFENCE_MANAGEMENT_SUCCESS';
export const UPDATE_GEOFENCE_MANAGEMENT_ERROR = 'UPDATE_GEOFENCE_MANAGEMENT_ERROR';

export const DELETE_GEOFENCE_MANAGEMENT = 'DELETE_GEOFENCE_MANAGEMENT';
